export default __webpack_public_path__ + "static/media/16_photo.bf6fb245.jpg";